/**
 * Created by guga on 7/21/2016.
 */

 export class SpacialBean {
    public x:number //how many of this item is base to be added on skill success
    public y: number; //sugested cost for item
    public z:number //max skill that is awareded on this item

    constructor (){
        this.x=0
        this.y=0
        this.z=0; //where it is equiped       
    }

    public parse(val){
        if (val){
            this.x=val.x
            this.y=val.y
            this.z=val.z   
        }
        else{
            this.x=0
            this.y=0
            this.z=0; //where it is equiped           
        }
    }
    public toDB(){
        return  {
            x:this.x,
            y:this.y,
            z:this.z
        }
    }

};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/spacial.bean.ts